import axios from "axios";
import axiosInstance from "../utilities/axiosSetup";

// Password Reset API functions
export const forgotPassword = async (email) => {
  const response = await axios.post(
    `${import.meta.env.VITE_API_URL}/forgot-password`,
    { email },
    { withCredentials: true }
  );
  return response.data;
};

export const resetPassword = async (
  email,
  code,
  newPassword,
  confirmPassword
) => {
  const response = await axios.post(
    `${import.meta.env.VITE_API_URL}/confirm-forgot-password`,
    { email, code, newPassword, confirmPassword },
    { withCredentials: true }
  );
  return response.data;
};

// Existing API functions below

// Existing authentication functions
export const initiate_login = async (email, password) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("email", email);
  FORM_DATA.append("password", password);
  let response = await axios.post(
    import.meta.env.VITE_API_URL + "/initiate-login",
    FORM_DATA,
    { withCredentials: true }
  );
  return response.data;
};

export const setup_mfa = async (session) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("Session", session);

  let response = await axios.post(
    import.meta.env.VITE_API_URL + "/setup-mfa",
    FORM_DATA,
    { withCredentials: true }
  );
  return response.data;
};

export const verify_mfa_setup_token = async (session, user_code) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("Session", session);
  FORM_DATA.append("UserCode", user_code);
  let response = await axios.post(
    import.meta.env.VITE_API_URL + "/verify-mfa-setup-token",
    FORM_DATA,
    { withCredentials: true }
  );
  return response.data;
};

export const verify_mfa = async (email, session, code) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("email", email);
  FORM_DATA.append("Session", session);
  FORM_DATA.append("UserCode", code);
  let response = await axios.post(
    import.meta.env.VITE_API_URL + "/verify-mfa",
    FORM_DATA,
    { withCredentials: true }
  );
  return response.data;
};

export const get_user_type = async () => {
  // Check both storage locations for token
  const token = sessionStorage.getItem("authToken");

  let response = await axiosInstance.get(
    import.meta.env.VITE_API_URL + "/get-user-type",
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "X-Zoom-User-Id": sessionStorage.getItem("z_user_id"),
      },
    }
  );
  return response.data;
};

export const auth_agent = async () => {
  let response = await axios.get(import.meta.env.VITE_API_URL + "/auth-agent", {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("authToken"),
    },
    withCredentials: true,
  });
  return response.data;
};

export const login_zoom = async (code, code_verifier) => {
  let response = await axios.post(
    import.meta.env.VITE_API_URL + "/login-zoom",
    { code: code, code_verifier: code_verifier },
    {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
      withCredentials: true,
    }
  );
  return response.data;
};

// This function might be deprecated in favor of resetPassword
export const confirm_new_password = async (email, session, newPassword) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("email", email);
  FORM_DATA.append("Session", session);
  FORM_DATA.append("new_password", newPassword);

  let response = await axios.post(
    import.meta.env.VITE_API_URL + "/confirm-new-password",
    FORM_DATA,
    { withCredentials: true }
  );
  return response.data;
};

export const refresh_token = async () => {
  try {
    // No need to send refresh token in the request body as it's in the HTTP-only cookie
    const response = await axios.post(
      import.meta.env.VITE_API_URL + "/refresh-token",
      {
        refresh_token: localStorage.getItem("refresh_token"),
      }, // Empty body since the refresh token is in the cookie
      {
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      } // Important to include cookies
    );
    return response.data;
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error;
  }
};

export const logout = async () => {
  try {
    // No need to send refresh token in the request body as it's in the HTTP-only cookie
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/logout",
      {}, // Empty body since the refresh token is in the cookie
      {
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      } // Important to include cookies
    );
    // Clear access token from sessionStorage
    sessionStorage.removeItem("authToken");
    return response.data;
  } catch (error) {
    console.error("Error during logout:", error);
    // Even if server-side logout fails, clear access token
    sessionStorage.removeItem("authToken");
    return { success: true };
  }
};
